import React, { FC } from 'react'

import { IconCloudUploadProps } from './IconCloudUpload.types'
import * as Styled from './styles/IconCloudUpload.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCloudUpload: FC<IconCloudUploadProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCloudUploadProps['size'],
  isResponsive = false,
}: IconCloudUploadProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M29.588 31.095s5.61.215 7.797-.75a9.56 9.56 0 0 0 5.57-7.75c.328-3.272-1.165-6.867-3.985-8.607-1.402-.863-3.04-1.213-4.677-1.355a19.705 19.705 0 0 0-2.793.117 10.922 10.922 0 0 0-9.485-7.613 10.655 10.655 0 0 0-8.93 3.775 11 11 0 0 0-2.227 4.365c-.108.426-.32 1.61-.32 1.61A8.393 8.393 0 0 0 7.57 16.57c-2.627 2.35-3.267 6.365-1.797 9.525 1.335 2.87 4.202 5 7.392 5h5.25'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24 19.285v23.793m-6.5-16.793 6.5-7 6.5 7' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCloudUpload
